export const TOUCH_GESTURE_THRESHOLD = 8;
const VERTICAL_DOMINANCE_RATIO = 1.8;

/**
 * Give horizontal galleries priority for diagonal swipes. The feed gets a
 * gesture only when vertical movement clearly outweighs horizontal drift.
 */
export function classifyTouchAxis(deltaX, deltaY) {
  const absX = Math.abs(Number(deltaX) || 0);
  const absY = Math.abs(Number(deltaY) || 0);
  if (Math.hypot(absX, absY) < TOUCH_GESTURE_THRESHOLD) return null;

  if (absX === 0) return 'vertical';
  if (absY === 0) return 'horizontal';
  if (absY >= absX * VERTICAL_DOMINANCE_RATIO) return 'vertical';
  return 'horizontal';
}
